// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6e-0";
export var startPickingButton = "_6e-1";